export class LocalizedField {
  constructor (params = {}) {
    params.forEach(language => {
      this[language.locale.toLowerCase()] = language.content
    })
  }
}
